export class AuditlogState {
  entityDetails = null;
}
